import { Link } from "react-router-dom";
import { MapPin, CalendarBlank } from "@phosphor-icons/react";

const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  } catch { return iso; }
};

export default function EventCard({ event, testId }) {
  const min = event.min_price ?? (event.ticket_types?.[0]?.price ?? 0);
  return (
    <Link
      to={`/events/${event.id}`}
      className="grid-card group block"
      data-testid={testId || `event-card-${event.id}`}
    >
      <div className="aspect-[4/3] overflow-hidden bg-neutral-100 dark:bg-neutral-800 relative rounded-t-lg">
        <img
          src={event.image_url}
          alt={event.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <span className="absolute top-3 left-3 bg-white dark:bg-neutral-900 dark:text-white text-black text-[10px] tracking-widest font-bold uppercase px-2.5 py-1 rounded-full shadow-sm">
          {event.category}
        </span>
      </div>
      <div className="p-5">
        <p className="label-eyebrow flex items-center gap-1.5">
          <CalendarBlank size={12} weight="bold" />
          {fmtDate(event.date)}
        </p>
        <h3 className="mt-2 font-display text-xl leading-tight tracking-tight line-clamp-2 group-hover:text-[#4F46E5] transition-colors dark:text-white">
          {event.title}
        </h3>
        <p className="mt-2 text-sm text-neutral-500 dark:text-neutral-400 flex items-center gap-1">
          <MapPin size={14} /> {event.venue}, {event.city}
        </p>
        <div className="mt-4 flex items-end justify-between">
          <div>
            <span className="text-[10px] tracking-widest font-bold uppercase text-neutral-400">From</span>
            <p className="font-display text-2xl dark:text-white">৳{min.toLocaleString()}</p>
          </div>
          <span className="text-xs font-bold uppercase tracking-widest text-[#4F46E5] group-hover:underline">Get Tickets →</span>
        </div>
      </div>
    </Link>
  );
}
